module.exports = __webpack_public_path__ + "img/pl.86527c2c.png";